export default __webpack_public_path__ + "static/media/ic_companysetting.bd17df83.svg";